import { useState, useRef, useEffect } from "react";

const REG_URL = "https://pages.razorpay.com/techvanto-academy-training";
const WA_URL = "https://wa.me/919646206032";

// ─── EmailJS Config ───────────────────────────────────────────────────────────
const EMAILJS_PUBLIC_KEY  = "CB7Wsiv5o7N6OvmQ3";
const EMAILJS_SERVICE_ID  = "service_pq585w9";
const EMAILJS_TEMPLATE_ID = "template_tyk7uuo";
const LEAD_RECIPIENT_EMAIL = "28shiva95@gmail.com";
// ─────────────────────────────────────────────────────────────────────────────

function loadEmailJS() {
  return new Promise((resolve) => {
    if (window.emailjs) { resolve(); return; }
    const s = document.createElement("script");
    s.src = "https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js";
    s.onload = () => { window.emailjs.init(EMAILJS_PUBLIC_KEY); resolve(); };
    document.head.appendChild(s);
  });
}

async function sendLeadToSheet({ name, phone, interest }) {
  await loadEmailJS();
  return window.emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, {
    from_name: name,
    phone:     phone,
    interest:  interest || "Not specified",
    to_email:  LEAD_RECIPIENT_EMAIL,
  });
}

const STATIC_AI_RESPONSES = {
  "What is machine learning? Explain in simple terms with a real-world example, in 3 sentences.":
    "Machine Learning is a branch of AI where computers learn patterns from data without being explicitly programmed. For example, Spotify learns your music taste and recommends new songs you'll likely enjoy. The more data it sees, the smarter and more accurate it becomes!",

  "What is the difference between Artificial Intelligence and Data Science? Keep it very concise.":
    "Artificial Intelligence focuses on building systems that simulate human intelligence — like making decisions or recognising speech. Data Science is about extracting insights from large datasets using statistics and programming. AI often uses Data Science techniques, but Data Science is broader and not always about building intelligent systems.",

  "What does a full stack developer do? Explain briefly for a beginner.":
    "A Full Stack Developer builds both the frontend (what users see — buttons, pages, forms) and the backend (the server, database, and logic behind the scenes). They are like an all-rounder who can build a complete web application from scratch. Popular tools include React for frontend and Node.js or Python for backend.",

  "Should a beginner start with Python? What can they build with it? Brief answer.":
    "Yes! Python is one of the best first languages — it has clean, readable syntax and a massive community. With Python you can build websites, data analysis tools, AI/ML models, automation scripts, and even games. It is also the top language in Data Science and AI, making it extremely career-friendly.",

  "What is Generative AI and how is it different from traditional AI? Give 2 real-world examples. Keep it brief.":
    "Generative AI can create new content — text, images, code, music — rather than just analysing existing data like traditional AI. For example, ChatGPT generates human-like text conversations, and Midjourney creates stunning images from text prompts. It is one of the hottest and fastest-growing fields in tech right now!",

  "What is Cyber Security and why is it a great career in 2025? Mention 2-3 key skills needed. Keep it concise.":
    "Cyber Security is the practice of protecting systems, networks, and data from digital attacks and unauthorised access. With cybercrime costs projected to hit $10 trillion globally, companies are urgently hiring security professionals. Key skills include ethical hacking, network security, and tools like Kali Linux and Wireshark.",

  "What is Cloud Computing? Explain with a simple analogy and mention top platforms like AWS, Azure, GCP. 3 sentences.":
    "Cloud Computing is like renting a powerful computer over the internet instead of buying one — you use only what you need and pay accordingly. It allows businesses to store data, run applications, and scale instantly without managing physical hardware. The top platforms are Amazon Web Services (AWS), Microsoft Azure, and Google Cloud Platform (GCP).",

  "What is DevOps and why do companies need it? Explain for a beginner in 3 sentences.":
    "DevOps brings together software development (Dev) and IT operations (Ops) to deliver applications faster and more reliably. Instead of teams working in silos, DevOps encourages collaboration, automation, and continuous delivery. Companies like Netflix and Amazon use DevOps to deploy code hundreds of times a day without downtime.",

  "What is the difference between React, Angular, and Vue.js? Which one should a beginner learn first and why? Keep it concise.":
    "React (by Meta) is a flexible UI library, Angular (by Google) is a full-featured framework, and Vue.js is a lightweight progressive framework. React is the most popular and in-demand in the job market, making it the best choice for most beginners. Once you know React well, picking up Angular or Vue becomes much easier.",

  "What is Blockchain technology and where is it used beyond cryptocurrency? Explain simply in 3 sentences.":
    "Blockchain is a decentralised digital ledger that records transactions across many computers so no single person can alter the data. Beyond cryptocurrency like Bitcoin, it is used in supply chain tracking, healthcare records, digital voting, and smart contracts. It is valued for its transparency, security, and ability to eliminate middlemen.",

  "What is the Internet of Things (IoT)? Give 2 real-life examples and explain why it is a growing field. Keep it brief.":
    "IoT refers to everyday physical devices connected to the internet that collect and share data — from smartwatches to industrial sensors. A smart thermostat learns your schedule and adjusts room temperature automatically, while smart factory machines detect faults before they break down. With billions of connected devices worldwide, IoT is one of the fastest-growing career fields in tech.",

  "What is Data Analytics and how is it different from Data Science? What tools are used? Concise answer.":
    "Data Analytics focuses on examining existing datasets to draw conclusions and support business decisions — think dashboards and reports. Data Science goes deeper, using machine learning and statistics to build predictive models and uncover hidden patterns. Key tools for analytics include Excel, Power BI, Tableau, and SQL, while Data Science also uses Python and R.",

  "What is prompt engineering and why is it an important skill in the AI era? Explain in 3 sentences for a beginner.":
    "Prompt engineering is the skill of crafting effective instructions to get the best results from AI models like ChatGPT or Claude. Just like knowing the right keywords improves a Google search, a well-structured prompt dramatically improves the AI output quality. It is rapidly becoming one of the most in-demand skills as AI tools get embedded in every industry.",

  "What is the difference between Android and iOS development? Which one should a beginner pick and why? Brief answer.":
    "Android development uses Kotlin or Java and targets a wider global audience since Android holds over 70% of the smartphone market. iOS development uses Swift and targets Apple users who typically have higher purchasing power. For beginners, Android is often recommended as it is easier to get started, has more free tools, and offers a larger job market in India.",
};

const DEFAULT_AI_RESPONSE =
  "That's a great question! For a detailed and personalised answer, we recommend speaking with one of our expert mentors. You can reach us on WhatsApp at +91 96462 06032 or email training@techvantoacademy.com — we're happy to help!";

const MENUS = {
  start: {
    text: (n) =>
      `Namaste, ${n}! Welcome to Techvanto Academy — Delhi's leading job-oriented tech training platform with a 100% placement guarantee.\n\nHow can I help you today?`,
    btns: [
      { l: "Explore courses", a: "courses" },
      { l: "Enroll / Register now", a: "enroll" },
      { l: "Batch schedule & timing", a: "schedule" },
      { l: "Placement & internship", a: "placement" },
      { l: "Ask a technical doubt", a: "doubt" },
    ],
  },
  courses: {
    text: () => "We offer job-oriented tech programs across multiple domains. Which area interests you?",
    btns: [
      { l: "AI / ML / Data Science", a: "ai_ml" },
      { l: "Full Stack / Web Dev", a: "fullstack" },
      { l: "Cyber Security", a: "cyber" },
      { l: "IoT / Embedded / Robotics", a: "iot" },
      { l: "Android / iOS Dev", a: "mobile" },
      { l: "Digital Marketing", a: "dm" },
      { l: "Back to main menu", a: "start" },
    ],
  },
  ai_ml: {
    text: () =>
      "Our AI / ML / Data Science programs include:\n\n• Artificial Intelligence & Machine Learning\n• Data Science with Python\n• Business Analytics\n\nAll include 60+ hrs live training, 90% practical, real projects, and full placement support. ISO certificate on completion.",
    showReg: true,
    btns: [{ l: "Register now", a: "enroll" }, { l: "View schedule", a: "schedule" }, { l: "Talk to advisor", a: "contact" }, { l: "Back to courses", a: "courses" }],
  },
  fullstack: {
    text: () =>
      "Our development programs:\n\n• Full Stack Development (React, Node.js)\n• Python / Java / C++ Programming\n• Android Development\n• iOS Development\n\nLearn from industry experts with real-world projects and 100% placement support.",
    showReg: true,
    btns: [{ l: "Register now", a: "enroll" }, { l: "View schedule", a: "schedule" }, { l: "Talk to advisor", a: "contact" }, { l: "Back to courses", a: "courses" }],
  },
  cyber: {
    text: () =>
      "Our security programs:\n\n• Cyber Security\n• Cyber Forensics\n\nCovers threat detection, ethical hacking, forensics tools, and industry certifications. 100% placement assistance included.",
    showReg: true,
    btns: [{ l: "Register now", a: "enroll" }, { l: "Talk to advisor", a: "contact" }, { l: "Back to courses", a: "courses" }],
  },
  iot: {
    text: () =>
      "Our hardware & embedded programs:\n\n• Internet of Things (IoT)\n• Embedded Systems & Robotics\n• VLSI Design\n• Wireless Communication\n\nHands-on lab-based training with research expert mentors.",
    showReg: true,
    btns: [{ l: "Register now", a: "enroll" }, { l: "Talk to advisor", a: "contact" }, { l: "Back to courses", a: "courses" }],
  },
  mobile: {
    text: () =>
      "We offer both Android and iOS Development training — covering app architecture, UI design, API integration, and publishing. Portfolio projects included.",
    showReg: true,
    btns: [{ l: "Register now", a: "enroll" }, { l: "Talk to advisor", a: "contact" }, { l: "Back to courses", a: "courses" }],
  },
  dm: {
    text: () =>
      "Our Digital Marketing program covers SEO, social media, Google Ads, content strategy, and analytics — ideal for building a career in the booming digital industry.",
    showReg: true,
    btns: [{ l: "Register now", a: "enroll" }, { l: "Talk to advisor", a: "contact" }, { l: "Back to courses", a: "courses" }],
  },
  enroll: {
    text: () =>
      "Ready to start your journey? Here's how to register:\n\n1. Click Register now below\n2. Fill in your details on our secure Razorpay page\n3. Choose your course & complete payment\n\nFor queries, call +91 96462 06032 or email training@techvantoacademy.com.",
    showReg: true,
    btns: [{ l: "Call / WhatsApp us", a: "contact" }, { l: "View courses", a: "courses" }, { l: "Back to main menu", a: "start" }],
  },
  schedule: {
    text: () =>
      "Techvanto offers flexible batch options:\n\n• Weekday batches — morning & evening slots\n• Weekend batches — Sat & Sun\n• Summer Training Program — 60hrs intensive\n• Recorded / self-paced options available\n\nCall +91 96462 06032 for current batch dates.",
    btns: [{ l: "Register now", a: "enroll" }, { l: "Talk to advisor", a: "contact" }, { l: "Back to main menu", a: "start" }],
  },
  placement: {
    text: () =>
      "Techvanto's 100% placement assistance includes:\n\n• Company-specific mock placement tests\n• Resume building sessions\n• Interview preparation drives\n• Hiring partners: Amazon, TCS, Infosys, Accenture, Zomato, Disney+ Hotstar, Barclays & more\n\n20,000+ students placed so far!",
    btns: [{ l: "Register now", a: "enroll" }, { l: "Explore courses", a: "courses" }, { l: "Talk to advisor", a: "contact" }, { l: "Back to main menu", a: "start" }],
  },
  contact: {
    text: () =>
      "Reach us anytime:\n\n• WhatsApp / Phone: +91 96462 06032\n• Email: training@techvantoacademy.com\n• Address: R-7 Main M.G. Road, Near Ghitorni Metro Station, Delhi\n\nAvailable Mon–Sat, 9 AM – 7 PM IST",
    showReg: true,
    btns: [{ l: "WhatsApp us now", a: "wa" }, { l: "Explore courses", a: "courses" }, { l: "Back to main menu", a: "start" }],
  },
  doubt: {
    text: () => "Ask me anything technical — coding, AI, data science, cyber security, or any tools you're learning!",
    btns: [
      { l: "What is machine learning?", a: "aiq_What is machine learning? Explain in simple terms with a real-world example, in 3 sentences." },
      { l: "AI vs Data Science?", a: "aiq_What is the difference between Artificial Intelligence and Data Science? Keep it very concise." },
      { l: "What is full stack dev?", a: "aiq_What does a full stack developer do? Explain briefly for a beginner." },
      { l: "Should I learn Python first?", a: "aiq_Should a beginner start with Python? What can they build with it? Brief answer." },
      { l: "What is Generative AI?", a: "aiq_What is Generative AI and how is it different from traditional AI? Give 2 real-world examples. Keep it brief." },
      { l: "What is Cyber Security?", a: "aiq_What is Cyber Security and why is it a great career in 2025? Mention 2-3 key skills needed. Keep it concise." },
      { l: "What is Cloud Computing?", a: "aiq_What is Cloud Computing? Explain with a simple analogy and mention top platforms like AWS, Azure, GCP. 3 sentences." },
      { l: "What is DevOps?", a: "aiq_What is DevOps and why do companies need it? Explain for a beginner in 3 sentences." },
      { l: "React vs Angular vs Vue?", a: "aiq_What is the difference between React, Angular, and Vue.js? Which one should a beginner learn first and why? Keep it concise." },
      { l: "What is Blockchain?", a: "aiq_What is Blockchain technology and where is it used beyond cryptocurrency? Explain simply in 3 sentences." },
      { l: "What is IoT?", a: "aiq_What is the Internet of Things (IoT)? Give 2 real-life examples and explain why it is a growing field. Keep it brief." },
      { l: "What is Data Analytics?", a: "aiq_What is Data Analytics and how is it different from Data Science? What tools are used? Concise answer." },
      { l: "What is prompt engineering?", a: "aiq_What is prompt engineering and why is it an important skill in the AI era? Explain in 3 sentences for a beginner." },
      { l: "Android vs iOS dev?", a: "aiq_What is the difference between Android and iOS development? Which one should a beginner pick and why? Brief answer." },
      { l: "Back to main menu", a: "start" },
    ],
  },
};

// ─── Sub-components ──────────────────────────────────────────────────────────

function TypingIndicator() {
  return (
    <div style={styles.botMsg}>
      <div style={styles.senderLabel}>Techvanto Bot</div>
      <div style={styles.typingDots}>
        {[0, 1, 2].map((i) => (
          <span key={i} style={{ ...styles.dot, animationDelay: `${i * 0.2}s` }} />
        ))}
      </div>
    </div>
  );
}

function RegisterBtn() {
  return (
    <a href={REG_URL} target="_blank" rel="noopener noreferrer" style={styles.regBtn}>
      ✍️ Register now
    </a>
  );
}

function ChatMessage({ msg }) {
  const isUser = msg.role === "user";
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: isUser ? "flex-end" : "flex-start", gap: 6 }}>
      <div style={isUser ? styles.userMsg : styles.botMsg}>
        {!isUser && <div style={styles.senderLabel}>Techvanto Bot</div>}
        <div style={{ whiteSpace: "pre-line" }}>{msg.text}</div>
        {msg.showReg && <RegisterBtn />}
        {msg.btns && msg.btns.length > 0 && (
          <div style={styles.quickBtns}>
            {msg.btns.map((b) => (
              <button key={b.l} style={styles.quickBtn} onClick={() => msg.onBtn(b.l, b.a)}>
                {b.l}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function LeadForm({ onSubmit }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [interest, setInterest] = useState("");
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);
  const [sendError, setSendError] = useState("");

  const validate = () => {
    const e = {};
    if (!name.trim()) e.name = "Please enter your name.";
    if (!/^[6-9]\d{9}$/.test(phone.trim())) e.phone = "Please enter a valid 10-digit phone number.";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate() || sending) return;
    setSending(true);
    setSendError("");
    const lead = { name: name.trim(), phone: phone.trim(), interest };
    try {
      await sendLeadToSheet(lead);
    } catch (err) {
      console.error("EmailJS error:", err);
      setSendError("(Note: email notification failed, but your details are saved.)");
    }
    setSending(false);
    onSubmit(lead);
  };

  return (
    <div style={styles.leadCard}>
      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <div style={styles.leadAvatar}>🎓</div>
        <h3 style={styles.leadTitle}>Start chatting with us</h3>
        <p style={styles.leadSubtitle}>
          Share a few quick details and our advisors will personalise your experience and follow up with you.
        </p>
      </div>

      <div style={styles.field}>
        <label style={styles.label}>Full name</label>
        <input
          style={{ ...styles.input, borderColor: errors.name ? "#e24b4a" : undefined }}
          placeholder="e.g. Rahul Sharma"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
        />
        {errors.name && <span style={styles.errText}>{errors.name}</span>}
      </div>

      <div style={styles.field}>
        <label style={styles.label}>WhatsApp / phone number</label>
        <input
          style={{ ...styles.input, borderColor: errors.phone ? "#e24b4a" : undefined }}
          placeholder="e.g. 9876543210"
          type="tel"
          maxLength={10}
          value={phone}
          onChange={(e) => setPhone(e.target.value.replace(/\D/, ""))}
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
        />
        {errors.phone && <span style={styles.errText}>{errors.phone}</span>}
      </div>

      <div style={styles.field}>
        <label style={styles.label}>I'm interested in</label>
        <select style={styles.select} value={interest} onChange={(e) => setInterest(e.target.value)}>
          <option value="">Select a course area</option>
          <option>AI / Machine Learning / Data Science</option>
          <option>Full Stack / Web Development</option>
          <option>Cyber Security</option>
          <option>Android / iOS Development</option>
          <option>IoT / Embedded Systems / Robotics</option>
          <option>Digital Marketing</option>
          <option>Other / Not sure yet</option>
        </select>
      </div>

      <button style={{...styles.submitBtn, opacity: sending ? 0.7 : 1}} onClick={handleSubmit} disabled={sending}>
        {sending ? "Sending..." : "Start chatting →"}
      </button>
      {sendError && <p style={{...styles.privacyNote, color: "#e24b4a"}}>{sendError}</p>}
      <p style={styles.privacyNote}>🔒 Your info is safe and won't be shared with third parties.</p>
    </div>
  );
}

// ─── Main Chatbot Component ───────────────────────────────────────────────────

export default function TechvantoChat() {
  const [open, setOpen] = useState(false);
  const [stage, setStage] = useState("lead"); // "lead" | "chat"
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);
  const [userName, setUserName] = useState("");
  const [unread, setUnread] = useState(1);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, typing]);

  useEffect(() => {
    if (open) setUnread(0);
  }, [open]);

  const addBotMsg = (text, btns = null, showReg = false, onBtn) => {
    setMessages((prev) => [...prev, { id: Date.now() + Math.random(), role: "bot", text, btns, showReg, onBtn }]);
  };

  const addUserMsg = (text) => {
    setMessages((prev) => [...prev, { id: Date.now() + Math.random(), role: "user", text }]);
  };

  const handleMenu = (label, action, currentUserName) => {
    addUserMsg(label);
    if (action === "wa") { window.open(WA_URL, "_blank"); return; }
    if (action.startsWith("aiq_")) { handleStaticReply(action.slice(4)); return; }
    const menu = MENUS[action];
    if (!menu) return;
    const uName = currentUserName || userName;
    setTimeout(() => {
      const handler = (l, a) => handleMenu(l, a, uName);
      addBotMsg(menu.text(uName), menu.btns, menu.showReg, handler);
    }, 350);
  };

  // Replaces callAI — uses static lookup, no API needed
  const handleStaticReply = (question) => {
    if (typing) return;
    setTyping(true);
    setTimeout(() => {
      const reply = STATIC_AI_RESPONSES[question] || DEFAULT_AI_RESPONSE;
      setTyping(false);
      const handler = (l, a) => handleMenu(l, a, userName);
      addBotMsg(reply, [
        { l: "Register now", a: "enroll" },
        { l: "Ask another doubt", a: "doubt" },
        { l: "Back to main menu", a: "start" },
      ], false, handler);
    }, 800);
  };

  // For free-text input — static keyword-based routing
  const handleSend = () => {
    const val = input.trim();
    if (!val || typing) return;
    setInput("");
    addUserMsg(val);

    setTyping(true);
    setTimeout(() => {
      setTyping(false);
      const handler = (l, a) => handleMenu(l, a, userName);

      const lower = val.toLowerCase();

      // Keyword routing
      if (lower.includes("fee") || lower.includes("price") || lower.includes("cost") || lower.includes("charge")) {
        addBotMsg(
          "Course fees vary depending on the program and batch. For the latest pricing and any available offers, please call or WhatsApp us at +91 96462 06032 or email training@techvantoacademy.com.",
          [{ l: "WhatsApp us now", a: "wa" }, { l: "Back to main menu", a: "start" }],
          false, handler
        );
      } else if (lower.includes("placement") || lower.includes("job") || lower.includes("hire")) {
        const menu = MENUS.placement;
        addBotMsg(menu.text(), menu.btns, menu.showReg, handler);
      } else if (lower.includes("course") || lower.includes("program") || lower.includes("learn")) {
        const menu = MENUS.courses;
        addBotMsg(menu.text(), menu.btns, menu.showReg, handler);
      } else if (lower.includes("schedule") || lower.includes("batch") || lower.includes("timing") || lower.includes("time")) {
        const menu = MENUS.schedule;
        addBotMsg(menu.text(), menu.btns, menu.showReg, handler);
      } else if (lower.includes("contact") || lower.includes("call") || lower.includes("reach") || lower.includes("address")) {
        const menu = MENUS.contact;
        addBotMsg(menu.text(), menu.btns, menu.showReg, handler);
      } else if (lower.includes("enroll") || lower.includes("register") || lower.includes("join") || lower.includes("admit")) {
        const menu = MENUS.enroll;
        addBotMsg(menu.text(), menu.btns, menu.showReg, handler);
      } else {
        // Fallback
        addBotMsg(
          "Thanks for your message! For personalised guidance, our advisors are available on WhatsApp at +91 96462 06032 or email training@techvantoacademy.com.\n\nMeanwhile, feel free to explore the options below:",
          [
            { l: "Explore courses", a: "courses" },
            { l: "Placement info", a: "placement" },
            { l: "Contact us", a: "contact" },
            { l: "Back to main menu", a: "start" },
          ],
          false, handler
        );
      }
    }, 800);
  };

  const handleLeadSubmit = ({ name, phone, interest }) => {
    const firstName = name.split(" ")[0];
    setUserName(firstName);
    setStage("chat");

    const handler = (l, a) => handleMenu(l, a, firstName);

    setTimeout(() => {
      addBotMsg(MENUS.start.text(firstName), MENUS.start.btns, false, handler);
    }, 400);

    if (interest && interest !== "Other / Not sure yet" && interest !== "") {
      setTimeout(() => {
        addBotMsg(
          `I see you're interested in ${interest} — great choice! Feel free to ask me anything about it.`,
          null, false, handler
        );
      }, 1200);
    }
  };

  return (
    <>
      {/* Floating toggle button */}
      <button
        onClick={() => setOpen((o) => !o)}
        style={styles.fab}
        aria-label={open ? "Close chat" : "Open chat"}
      >
        {open ? "✕" : "💬"}
        {!open && unread > 0 && <span style={styles.unreadBadge}>{unread}</span>}
      </button>

      {/* Chat window */}
      {open && (
        <div style={styles.window}>
          {/* Header */}
          <div style={styles.header}>
            <div style={styles.headerAvatar}>🎓</div>
            <div style={{ flex: 1 }}>
              <div style={styles.headerName}>Techvanto Academy</div>
              <div style={styles.headerStatus}>
                <span style={styles.onlineDot} /> Online — replies instantly
              </div>
            </div>
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" style={styles.waIcon} title="WhatsApp us">
              💬
            </a>
            <button onClick={() => setOpen(false)} style={styles.closeBtn} aria-label="Close">✕</button>
          </div>

          {/* Body */}
          <div style={styles.body}>
            {stage === "lead" ? (
              <LeadForm onSubmit={handleLeadSubmit} />
            ) : (
              <div style={styles.msgList}>
                {messages.map((msg) => (
                  <ChatMessage key={msg.id} msg={msg} />
                ))}
                {typing && <TypingIndicator />}
                <div ref={bottomRef} />
              </div>
            )}
          </div>

          {/* Input row — only in chat stage */}
          {stage === "chat" && (
            <div style={styles.inputRow}>
              <input
                style={styles.textInput}
                placeholder="Type your question..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSend()}
              />
              <button style={styles.sendBtn} onClick={handleSend} aria-label="Send">
                ➤
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
}

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = {
  fab: {
    position: "fixed",
    bottom: 130,
    right: 24,
    width: 56,
    height: 56,
    borderRadius: "50%",
    background: "#185FA5",
    color: "#fff",
    border: "none",
    fontSize: 22,
    cursor: "pointer",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 16px rgba(24,95,165,0.35)",
    transition: "transform 0.15s",
  },
  unreadBadge: {
    position: "absolute",
    top: 6,
    right: 6,
    width: 16,
    height: 16,
    borderRadius: "50%",
    background: "#e24b4a",
    color: "#fff",
    fontSize: 10,
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  window: {
    position: "fixed",
    bottom: 168,
    right: 24,
    width: 360,
    maxHeight: 580,
    borderRadius: 16,
    background: "#f5f5f0",
    boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
    display: "flex",
    flexDirection: "column",
    zIndex: 9998,
    overflow: "hidden",
    fontFamily: "'Segoe UI', system-ui, sans-serif",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "12px 14px",
    background: "#fff",
    borderBottom: "0.5px solid rgba(0,0,0,0.08)",
    flexShrink: 0,
  },
  headerAvatar: {
    width: 38,
    height: 38,
    borderRadius: "50%",
    background: "#E6F1FB",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 18,
    flexShrink: 0,
  },
  headerName: { fontSize: 13.5, fontWeight: 600, color: "#111" },
  headerStatus: { fontSize: 11.5, color: "#3B6D11", display: "flex", alignItems: "center", gap: 4, marginTop: 1 },
  onlineDot: { width: 7, height: 7, borderRadius: "50%", background: "#639922", display: "inline-block" },
  waIcon: { fontSize: 18, textDecoration: "none", color: "#3B6D11" },
  closeBtn: { background: "none", border: "none", fontSize: 16, cursor: "pointer", color: "#888", padding: 4 },
  body: {
    flex: 1,
    overflowY: "auto",
    padding: 12,
  },
  msgList: { display: "flex", flexDirection: "column", gap: 10 },
  botMsg: {
    maxWidth: "82%",
    background: "#fff",
    border: "0.5px solid rgba(0,0,0,0.08)",
    borderRadius: "12px 12px 12px 3px",
    padding: "10px 13px",
    fontSize: 13,
    lineHeight: 1.55,
    color: "#111",
    alignSelf: "flex-start",
  },
  userMsg: {
    maxWidth: "82%",
    background: "#185FA5",
    borderRadius: "12px 12px 3px 12px",
    padding: "10px 13px",
    fontSize: 13,
    lineHeight: 1.55,
    color: "#fff",
    alignSelf: "flex-end",
  },
  senderLabel: { fontSize: 10.5, color: "#888", marginBottom: 4, fontWeight: 600, letterSpacing: 0.3 },
  quickBtns: { display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8 },
  quickBtn: {
    background: "#E6F1FB",
    color: "#0C447C",
    border: "0.5px solid #85B7EB",
    borderRadius: 20,
    padding: "5px 11px",
    fontSize: 11.5,
    cursor: "pointer",
    fontFamily: "inherit",
    transition: "background 0.15s",
  },
  regBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    marginTop: 10,
    background: "#185FA5",
    color: "#fff",
    textDecoration: "none",
    borderRadius: 8,
    padding: "8px 14px",
    fontSize: 12.5,
    fontWeight: 600,
    fontFamily: "inherit",
    transition: "opacity 0.15s",
  },
  typingDots: { display: "flex", gap: 4, alignItems: "center", padding: "4px 0" },
  dot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "#aaa",
    display: "inline-block",
    animation: "tvBlink 1.2s infinite",
  },
  inputRow: {
    display: "flex",
    gap: 8,
    padding: "10px 12px",
    background: "#fff",
    borderTop: "0.5px solid rgba(0,0,0,0.08)",
    flexShrink: 0,
  },
  textInput: {
    flex: 1,
    border: "0.5px solid rgba(0,0,0,0.15)",
    borderRadius: 8,
    padding: "8px 12px",
    fontSize: 13,
    fontFamily: "inherit",
    outline: "none",
    background: "#f9f9f7",
  },
  sendBtn: {
    background: "#185FA5",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "0 14px",
    fontSize: 16,
    cursor: "pointer",
    transition: "opacity 0.15s",
    fontFamily: "inherit",
  },
  leadCard: {
    background: "#fff",
    borderRadius: 12,
    border: "0.5px solid rgba(0,0,0,0.08)",
    padding: "20px 16px",
  },
  leadAvatar: { fontSize: 32, marginBottom: 10 },
  leadTitle: { fontSize: 15, fontWeight: 600, color: "#111", marginBottom: 6 },
  leadSubtitle: { fontSize: 12.5, color: "#666", lineHeight: 1.5 },
  field: { marginBottom: 12 },
  label: { display: "block", fontSize: 11.5, color: "#555", marginBottom: 4, fontWeight: 600 },
  input: {
    width: "100%",
    border: "0.5px solid rgba(0,0,0,0.2)",
    borderRadius: 8,
    padding: "8px 11px",
    fontSize: 13,
    fontFamily: "inherit",
    outline: "none",
    boxSizing: "border-box",
    background: "#f9f9f7",
  },
  select: {
    width: "100%",
    border: "0.5px solid rgba(0,0,0,0.2)",
    borderRadius: 8,
    padding: "8px 11px",
    fontSize: 13,
    fontFamily: "inherit",
    outline: "none",
    background: "#f9f9f7",
    cursor: "pointer",
  },
  errText: { fontSize: 11, color: "#e24b4a", marginTop: 3, display: "block" },
  submitBtn: {
    width: "100%",
    padding: "10px",
    borderRadius: 8,
    background: "#185FA5",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    fontSize: 13.5,
    fontWeight: 600,
    fontFamily: "inherit",
    marginTop: 4,
    transition: "opacity 0.15s",
  },
  privacyNote: { textAlign: "center", fontSize: 11, color: "#999", marginTop: 10 },
};

if (typeof document !== "undefined" && !document.getElementById("tv-chat-styles")) {
  const style = document.createElement("style");
  style.id = "tv-chat-styles";
  style.textContent = `@keyframes tvBlink { 0%,80%,100%{opacity:0.2} 40%{opacity:1} }`;
  document.head.appendChild(style);
}